import { Check, CloudOff, Loader2 } from "lucide-react";

const DOTS = {
  "New Project": "#b9ad97",
  "Consultation In Progress": "#c2a172",
  "Awaiting Agreement / Deposit": "#9a6b3c",
  "Assessment Pending": "#a08a6d",
  "Ready for Design": "#8a9a84",
  "Concept in Progress": "#8a9a84",
  "Concept Awaiting Approval": "#9a6b3c",
  "Concept Approved / Payment Due": "#9a6b3c",
  "Product Selection in Progress": "#6f8269",
  "Product Approval Pending": "#9a6b3c",
  "Final Payment Due": "#9a6b3c",
  "Ordering / Final Delivery": "#5f6f5a",
  "Completed": "#3f4d3b",
};

export const money = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 })}`;

export const when = (iso) => new Date(iso).toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });

export const StatusLabel = ({ status, testId }) => (
  <span className="st-status" style={{ "--dot": DOTS[status] }} data-testid={testId}>{status}</span>
);

export const PageHead = ({ eyebrow, title, lead, children }) => (
  <header className="st-head">
    <div>
      {eyebrow && <p className="st-eyebrow">{eyebrow}</p>}
      <h1 className="st-h1" data-testid="studio-page-title">{title}</h1>
      {lead && <p className="st-lead">{lead}</p>}
    </div>
    {children && <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>{children}</div>}
  </header>
);

export const SaveIndicator = ({ state }) => {
  const map = {
    idle: [null, ""],
    pending: [<Loader2 key="p" size={13} className="animate-spin" />, "Editing…"],
    saving: [<Loader2 key="s" size={13} className="animate-spin" />, "Saving…"],
    saved: [<Check key="c" size={13} />, "Saved"],
    error: [<CloudOff key="e" size={13} />, "Not saved — retrying on next change"],
  };
  const [icon, text] = map[state] || map.idle;
  return <span className={`st-save is-${state}`} data-testid="project-save-indicator">{icon}{text}</span>;
};

export const roomFeeText = (r) => {
  if (r.pending) return r.fee_source === "custom" ? "Custom fee pending" : "Staff fee pending";
  return money(r.fee);
};

export const FEE_SOURCE = { auto: "Standard", staff: "Staff-entered", custom: "Custom (oversize)" };
